import { Outlet } from "react-router-dom";
import { useEffect } from "react";

import { TopBar } from "./TopBar";
import { OfflineBanner } from "./OfflineBanner";
import { ErrorBoundary } from "../common/ErrorBoundary";
import { useWebSocket } from "../../hooks/useWebSocket";
import { me } from "../../api/auth";
import { useAuthStore } from "../../store/authStore";

export default function AppShell() {
  const setUser = useAuthStore((s) => s.setUser);
  useWebSocket();

  useEffect(() => {
    me().then(setUser).catch(() => {});
  }, [setUser]);

  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden">
      <TopBar />
      <OfflineBanner />
      <main className="flex-1 overflow-hidden">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
